import { Examples } from '@/types';

export const ExampleDebugRoutes =
  process.env.NODE_ENV !== 'production'
    ? [
      {
        ...Examples.ExampleDebug,
        components: {
          default: () => import(/* webpackChunkName: "ExampleDebug" */ 
          '@/views/examples/ExampleDebug.vue')
        }
      }
    ]
    : [];